import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import {
  contactChangeMindset,
  contactRelationship,
  contactRoles,
  contactStatus,
} from '../../config/sources'

export const contactStatusSource = new Crud({
  fetcher: new Static(contactStatus),
  keyField: 'id',
})

export const contactRolesSource = new Crud({
  fetcher: new Static(contactRoles),
  keyField: 'id',
})

export const contactChangeMindsetSource = new Crud({
  fetcher: new Static(contactChangeMindset),
  keyField: 'id',
})

export const contactRelationshipSource = new Crud({
  fetcher: new Static(contactRelationship),
  keyField: 'id',
})
